
/* injects from baggage-loader */

( function() {
  function addCombo( editor, comboName, styleType, lang, entries, defaultLabel, styleDefinition, order ) {
    var config = editor.config,style = new CKEDITOR.style( styleDefinition );
    var styles = {};

    editor.ui.addRichCombo( comboName, {
      label: editor.lang.fontweight.title,
      title: editor.lang.fontweight.title,
      toolbar: 'styles,' + order,
      allowedContent: style,
      requiredContent: style,
      panel: {
        css: [ CKEDITOR.skin.getPath( 'editor' ) ].concat( config.contentsCss ),
        multiSelect: false,
        attributes: { 'aria-label': editor.lang.fontweight.title }
      },

      buildListFontWeight: function(){
        this.editor = editor
        var rebuildListFontWeight = CKEDITOR.tools.bind(buildListFontWeight, this);
        rebuildListFontWeight();
      },

      init: function() {
        var rebuildListFontWeight = CKEDITOR.tools.bind(buildListFontWeight, this);
        $(editor).bind('rebuildListFontWeight', rebuildListFontWeight);
        this.buildListFontWeight();
        this.startGroup(editor.lang.fontweight.title);
      },

      reBuildStyles: function(sizes) {
        for ( var i = 0; i < sizes.length; i++ ) {
          size = sizes[i]
          var vars = {}
          vars["size"] = size
          styles[ size ] = new CKEDITOR.style( styleDefinition, vars );
          styles[ size ]._.definition.name = size;
        }
      },
      onClick: function( value ) {
        // Create style objects for all sizes.
        for ( var i = 0; i < sizes.length; i++ ) {
          size = sizes[i]
          var vars = {}
          vars["size"] = size
          styles[ size ] = new CKEDITOR.style( styleDefinition, vars );
          styles[ size ]._.definition.name = size;
        }
        editor.focus();
        editor.fire( 'saveSnapshot' );
        var style = styles[ value ];
        editor[ this.getValue() == value ? 'removeStyle' : 'applyStyle' ]( style );
        editor.fire( 'saveSnapshot' );
      },
      onRender: function() {
        editor.on( 'selectionChange', function( ev ) {

          var currentValue = this.getValue();
          var elementPath = ev.data.path,elements = elementPath.elements;

          for ( var i = 0, element; i < elements.length; i++ ) {
            element = elements[ i ];
            for ( var value in styles ) {
              if ( styles[ value ].checkElementMatch( element, true, editor ) ) {
                if ( value != currentValue )
                  this.setValue( value );
                return;
              }
            }
          }
          this.setValue( '', defaultLabel );
        }, this );
      },
      refresh: function() {
        if ( !editor.activeFilter.check( style ) )
          this.setState( CKEDITOR.TRISTATE_DISABLED );
      }
    } );
  }
  CKEDITOR.plugins.add( 'fontweight', {
    requires: 'richcombo',
    lang: 'en,fr,es',
    init: function( editor ) {
      var config = editor.config;
      addCombo( editor, 'fontweight', 'size', editor.lang.fontweight.title, config.font_weight, editor.lang.fontweight.title, config.fontWeight_style, 40 );
    }
  } );
} )();


var buildListFontWeightHasRunOnce = 0;
var buildListFontWeight = function () {

  if (this.editor.ui.instances.FontFamily.sizes.length == 0)
    sizes = CKEDITOR.config.font_weight
  else
    sizes = this.editor.ui.instances.FontFamily.sizes || CKEDITOR.config.font_weight

  this.reBuildStyles(sizes)

  if (buildListFontWeightHasRunOnce) {
      // Remove the old unordered list from the dom.
      // This is just to cleanup the old list within the iframe
      if (this._.panel)
        $(this._.panel._.iframe.$).contents().find(".sizefield").parents(".cke_panel_block").find("ul").remove()
      // reset list
      this._.items = {};
      if (this._.list)
        this._.list._.items = {};
  }

  for ( var i = 0; i < sizes.length; i++ ) {
    var size = sizes[ i ];
    // Add the tag entry to the panel list.
    italic = size.indexOf("italic") > -1
    if (this._.list && !italic)
      this.add( size, "<span class='sizefield listitem'>" + size + "</span>", size );
  }

  if (buildListFontWeightHasRunOnce) {
      // Force CKEditor to commit the html it generates through this.add
      if (this._.list) {
        this._.committed = 0; // We have to set to false in order to trigger a complete commit()
        this.commit();
      }
  }
  buildListFontWeightHasRunOnce = 1;
};


CKEDITOR.config.font_weight = ['normal','bold','bolder','lighter','100','200','300','400','500','600','700','800','900'];
CKEDITOR.config.fontWeight_style = {
  element: 'span',
  styles: {
    "font-weight": "#(size)"
  },
  overrides: [ {
    element: 'font-weight', attributes: { 'size': null }
  } ]
};



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/fontweight/plugin.js